// * ========================================================================
// * video popup
// * ========================================================================

'use strict';

import $ from 'jquery';
import 'magnific-popup';

const magnificPopupVideo = {

  /**
   * Initializes elements on the page
   * @param {string|jQuery.htmlElment} element selector or Html element
   */
  init( element ) {
    const $items = $(element);

    $items.each((index, element) => {
      const $element = $(element);
      const source = $element.data('youtube');
      $element.magnificPopup({
        src: source,
        disableOn: 700,
        type: 'iframe',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false
      });
    });
  }

}
export default magnificPopupVideo;
